import { useMemo } from 'react';

import { useIsQuestionsOnlyMode } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

import { useDraftPostSettings, useScheduledPostSettings } from '.';

export const usePendingPostSettings: UseMainUIFeatureSettings<'pendingPost'> = (options) => {
  const pendingPostOverrides = options?.overrides?.pendingPost;
  const { [uiFeatureAccessSymbol]: isDraftPostEnabled } = useDraftPostSettings();
  const { [uiFeatureAccessSymbol]: isScheduledPostEnabled } = useScheduledPostSettings();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        isDraftPostEnabled: false,
        isScheduledPostEnabled: false,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isDraftPostEnabled || isScheduledPostEnabled,
      isDraftPostEnabled,
      isScheduledPostEnabled,
      ...pendingPostOverrides,
    };
  }, [isQuestionsOnlyMode, isDraftPostEnabled, isScheduledPostEnabled, pendingPostOverrides]);
};
